// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2rDmg","footer":"ModalInfo_footer__abQ9r"};